import { render, staticRenderFns } from "./KpiAfspraak.vue?vue&type=template&id=45003666"
import script from "./KpiAfspraak.vue?vue&type=script&lang=js"
export * from "./KpiAfspraak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports